import React from 'react';

import SnapshotRow from './SnapshotRow';
import Bar from './../Bar';
import { chunk } from '../../../helpers';
import StatisticsService from '../../../services/StatisticsService';
import './Snapshots.css';

interface Props {
  posts: Array<ReportPost>;
  organicCampaigns: number;
  showInPerson?: boolean;
  showComments?: boolean;
  views?: number;
}

function Snapshots(props: Props) {
  const unique = StatisticsService.filterUniquePosts(props.posts);
  const uniqueIds = unique.map((item) => item.id);
  const posts = props.posts.map((post) => ({ ...post, unique: uniqueIds.includes(post.id) }));
  const likes = StatisticsService.likes(unique);
  const comments = StatisticsService.comments(unique);
  const postsSplit = chunk(posts, 6);
  const firstRow = postsSplit[0];
  const otherRows = postsSplit.slice(1);

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <div className="page-break">
        <Bar
          title="INSTAGRAM ACTION"
          info={[
            ['', props.posts.length.toString(), 'Total Posts'],
            props.showComments ? ['', likes.toLocaleString(), 'Likes'] : [],
            props.showComments ? ['', comments.toLocaleString(), 'Comments'] : [],
            ['', props.organicCampaigns, 'Organic Campaigns'],
            props.showInPerson && props.views
              ? ['Reaching', props.views.toLocaleString(), 'Viewers']
              : [],
          ]}
        />
        {firstRow && <SnapshotRow key={firstRow[0].id} posts={firstRow} />}
      </div>
      {otherRows && otherRows.map((obj, i) => <SnapshotRow key={obj[0].id} posts={obj} />)}
    </div>
  );
}

export default Snapshots;
